import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';
import { useSelector } from 'react-redux';

const EditButtonChooseProfileScreen = ({
    setIsEditMode,
    isEditMode,
}) => {

    const { theme } = useSelector((state) => state.application);

    const { ref: editRef, focused: editFocused, setFocus } = useFocusable({
        focusKey: "edit-profile",
        autoRestoreFocus: true,
        trackChildren: true,
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
        onEnterRelease: () => { setIsEditMode(!isEditMode); },
    });

    return (
        <FocusContext.Provider value={"edit-profile"}>
            <span ref={editRef} style={{ position: "absolute", right: "20px", top: "20px" }} onClick={() => { setIsEditMode(!isEditMode); setFocus("choose-profile") }}>
                {isEditMode ? <span style={{ fontWeight: "bold", color: editFocused ? "#007FFF" : theme?.general?.color ?? "#ffffff", cursor: "pointer" }}>Done</span> : <i className='fa fa-pencil fa-lg' style={{ color: editFocused ? "#007FFF" : theme?.general?.color ?? "#ffffff", cursor: "pointer" }} />}
            </span>
        </FocusContext.Provider>
    );
}

export default EditButtonChooseProfileScreen;
